import React from 'react'
import { useSelector } from 'react-redux'
import ProjectsList from '../contentPages/ProjectsList'

const ProjectsLibrary = () => {
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo: user } = userLogin
	const userId = user._id

	return <ProjectsList userId={userId} />
}

export default ProjectsLibrary
